export const forceEnterpriseMigrationQuery =
  /[?&]forceEnterpriseMigration=true/i;
export const forceInactiveMigrationQuery = /[?&]forceInactiveMigration=true/i;
